<template>
    <el-row :gutter="50">
        <el-col :span="12">
            <el-form :model="form" label-width="auto">
                <el-form-item label="模型">
                    <el-radio-group v-model="form.engine">
                        <el-radio-button label="GPT-3.5" value="gpt" />
                        <el-radio-button label="Gemini" value="gemini" />
                        <el-radio-button label="文心一言" value="ernie" />
                        <el-radio-button label="GLM-3-turbo" value="chatglm" />
                        <el-radio-button label="百川" value="baichuan" />
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="提问">
                    <el-select v-model="form.promptKey" placeholder="" filterable @change="handleSelectPrompt">
                        <el-option label="空" :value="-1" />
                        <el-option :label="v.id + '. ' + v.title" :value="k" v-for="(v, k) in promptList" />
                    </el-select>
                </el-form-item>
                <el-form-item label=" ">
                    <el-input v-model="form.prompt" type="textarea" :autosize="{ minRows: 3, maxRows: 10 }" placeholder="请给出这本书的目录" />
                </el-form-item>
                <el-form-item label="温度">
                    <el-input v-model="form.temperature" placeholder="" />
                </el-form-item>
                <el-form-item label="内容">
                    <el-select v-model="form.issueKey" placeholder="" filterable @change="handleSelectContent">
                        <el-option label="空" :value="-1" />
                        <el-option :label="v.id + '. ' + v.title" :value="k" v-for="(v, k) in issueList" />
                    </el-select>
                </el-form-item>
                <el-form-item label=" ">
                    <el-input v-model="form.issue" type="textarea" :autosize="{ minRows: 3, maxRows: 10 }" placeholder="三国演义" />
                </el-form-item>
                <el-form-item>
                    <div style="width: 100%; text-align: center">
                        <el-button type="primary" @click="handleSubmit" v-if="status == 0">提问</el-button>
                        <el-button type="danger" @click="handleCancel" v-else-if="status == 1">取消</el-button>
                    </div>
                </el-form-item>
            </el-form>
        </el-col>
        <el-col :span="12" v-if="history.length > 0">
            <el-card>
                <template #header>
                    <div class="card-header">
                        <span>回答</span>
                    </div>
                </template>
                <el-collapse v-model="currentHistory">
                    <el-collapse-item :name="k" v-for="(v, k) in history">
                        <template #title>
                            {{ v.engine }} | {{ v.temperature }} | {{ v.promptTitle }} | {{ v.issueTitle }}
                            <el-button size="small" type="danger" text v-if="status == 0" @click="handleDelHistory(k)">删除</el-button>
                        </template>
                        <div v-html="parseMd2Html(v.answer)"></div>
                    </el-collapse-item>
                </el-collapse>
                <template #footer v-if="status == 1">
                    <div v-loading="true"></div>
                </template>
            </el-card>
        </el-col>
    </el-row>
</template>

<script>
import * as api from '@/api';
const { marked } = require('marked');

export default {
    data() {
        return {
            promptList: [],
            issueList: [],
            form: {
                engine: 'gemini',
                promptKey: -1,
                promptTitle: '',
                prompt: '',
                temperature: 0.9,
                issueKey: -1,
                issueTitle: '',
                issue: '',
            },

            currentHistory: 0,
            history: [],
            status: 0,
            answer: '',
        };
    },

    mounted() {
        api.getPromptList().then(res => {
            this.promptList = res.data;
        });
        api.getIssueList().then(res => {
            this.issueList = res.data;
        });
    },

    methods: {
        handleSelectPrompt(k) {
            if (k == -1) {
                this.form.prompt = '';
                this.form.promptTitle = '';
                this.form.temperature = 0.9;
                return;
            }
            this.form.promptTitle = this.promptList[k].title;
            this.form.prompt = this.promptList[k].content;
            this.form.temperature = this.promptList[k].temperature;
        },

        handleSelectContent(k) {
            if (k == -1) {
                this.form.content = '';
                return;
            }
            this.form.issueTitle = this.issueList[k].title;
            this.form.issue = this.issueList[k].content;
        },

        handleCancel() {
            api.aiAbort();
        },

        handleSubmit() {
            if (this.status == 1) {
                return;
            }
            this.status = 1;

            const { engine, prompt, promptTitle, temperature, issue, issueTitle } = this.form;

            this.history.push({
                engine,
                prompt,
                promptTitle,
                temperature,
                issue,
                issueTitle,
                answer: '',
            });
            this.currentHistory = this.history.length - 1;

            api.aiAsk(
                engine,
                prompt,
                issue,
                temperature,
                res => {
                    const current = this.history[this.currentHistory];
                    res.data.choices.forEach(v => {
                        current.answer += v.delta.text || '';
                    });
                    current.answer = current.answer.replace(/\*\*(.*?)\*\*/g, '$1');
                },
                res => {
                    this.status = 0;
                }
            );
        },

        handleDelHistory(k) {
            this.history.splice(k, 1);
        },

        parseMd2Html(md) {
            return marked.parse(md.replaceAll('\n', '\n\n'));
        },
    },
};
</script>
